import React, { createContext, useContext, useEffect, useState } from 'react';
import { getCurrentSubSupervisor, primeCsrf, subSupervisorLogin, subSupervisorLogout } from '../api/auth';

const SubSupervisorAuthContext = createContext(null);

export const SubSupervisorAuthProvider = ({ children }) => {
  const [subSupervisor, setSubSupervisor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await primeCsrf();
        const current = await getCurrentSubSupervisor();
        if (!cancelled) setSubSupervisor(current);
      } catch (err) {
        // Pas de session sous-superviseur active — reste sur l'ecran de login.
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const login = async (username, password) => {
    const loggedIn = await subSupervisorLogin(username, password);
    setSubSupervisor(loggedIn);
    return loggedIn;
  };

  const logout = async () => {
    // Best-effort : si la session etait deja expiree/invalide cote serveur (ex.
    // double-clic sur "Deconnexion"), l'etat vise ("plus authentifie") est de
    // toute facon deja atteint — on ne bloque jamais la navigation pour ca.
    try {
      await subSupervisorLogout();
    } catch (err) {
      // ignore
    }
    setSubSupervisor(null);
  };

  return (
    <SubSupervisorAuthContext.Provider value={{ subSupervisor, loading, login, logout }}>
      {children}
    </SubSupervisorAuthContext.Provider>
  );
};

export const useSubSupervisorAuth = () => {
  const ctx = useContext(SubSupervisorAuthContext);
  if (!ctx) throw new Error('useSubSupervisorAuth must be used within a SubSupervisorAuthProvider');
  return ctx;
};
